import React from 'react';
import ReactDOM from 'react-dom';
import { Form, Input } from 'antd';
const FormItem = Form.Item;
const TextArea = Input.TextArea;
import { bindValue, bindEvent, setFormCtlLayout, AddFormCtlCommonAttribute } from './sgiFormCtlComm';
import { sgiFormCtlBaseFun } from "./sgiFormCtlBaseFun";

class SgiFormTextArea extends React.Component {

    static defaultProps = {
    };  // 注意这里有分号
    static propTypes = {
    };  // 注意这里有分号

    constructor(props) {
        super(props);

        //初始化state属性
        this.initState();
    }

    /**
     * 根据描述创建文本框
     * @param {父组件} parentModule
     * @param {组件描述} moduleDesc
     * @param {绑定实例ID} bdInst
     * @param {当前工作区} ws
     * @param {make类型} type
     */
    textArea_mk(parentModule, moduleDesc, bdInst, objFct, type) {

        //获取需要展示的数据信息
        var moduleDesc = this.props.moduleDesc;
        if (!moduleDesc) {
            return;
        }
        //转换基础属性
        this.AddInputAttribute(moduleDesc, this.state.formItemProps, this.state.inputprops);
        //转换form公共属性
        AddFormCtlCommonAttribute(this, moduleDesc, this.state.formItemProps, this.state.inputprops);
        //设置布局
        setFormCtlLayout(moduleDesc, this.state.formItemProps, this.state.inputprops);
        //绑定值
        bindValue(this, moduleDesc, bdInst, objFct, this.state.formItemProps, this.state.inputprops);
        //绑定事件
        bindEvent(this, moduleDesc, this.state.formItemProps, this.state.inputprops, this.state.functions, type);
    }


    /**
     * 属性转换
     * @param {描述信息} moduleDesc
     * @param {属性} formItem
     * @param {属性} inputprops
     */
    AddInputAttribute(moduleDesc, formItem, inputprops) {
        var ctlRow = moduleDesc.ctlRow; //行数
        if (ctlRow) inputprops.rows = ctlRow;
        // autosize自适应内容高度，可设置为 true|false 或对象：{ minRows: 2, maxRows: 6 }，默认false
        // true：没有滚动条且rows不好用，false：有滚动条
        var isScl = moduleDesc.isScl; //滚动条
        if (!isScl) inputprops.autosize = !isScl;

        //校验类型 ??未实现
        var vldC = moduleDesc.vldC;

        //csstyle 样式文件?这个我还不知道怎么用
        var csstyle = moduleDesc.csstyle;
    }



    //渲染并返回一个虚拟DOM
    render = function () {

        if (!this.loaded) {
            var { parentModule, moduleDesc, bdInst, objFct, type } = this.props;
            //组装属性 初始化属性到this.state
            this.textArea_mk(parentModule, moduleDesc, bdInst, objFct, type);
            this.loaded = true;
        }

        // 合并相同属性，例如disabled属性，应由自身disabled属性及formDisabled属性同时控制
        const { _inputProps, _formItemProps } = this.getReviseProps();
        const { isLabel } = _inputProps;

        // 渲染前通用处理，如自定义样式等
        this.renderBeforeReturn();

        let ctl = (isLabel)
            ? <span {...this.state.inputprops} {..._inputProps}>{this.state.inputprops.value}</span>
            : <TextArea  {...this.state.inputprops} {..._inputProps} />;

        return this.state.noFI ? ctl : <FormItem {...this.state.formItemProps} {..._formItemProps}>{ctl}</FormItem>;
    }
}

//给类添加公共方法
Object.assign(SgiFormTextArea.prototype, sgiFormCtlBaseFun);

export { SgiFormTextArea };
export default SgiFormTextArea;



// WEBPACK FOOTER //
// ./~/rt-sd-comp/sgiComp/SgiFormTextArea.js